import { isNil } from 'ramda'

export const PROMPTON_CORP_OFFICE_KEYS = ['035200', '035201']

type ExternalInfo = {
  external_url: string
  office_key: string
  source_info_abbreviation: string
  source_info_name: string
  external_edit_url?: string
}
export const getEditMlsListingLink = (externalInfo?: ExternalInfo) => {
  if (isNil(externalInfo))
    return {
      allowEdit: false,
      link: ''
    }
  const allowEdit = PROMPTON_CORP_OFFICE_KEYS.includes(externalInfo.office_key)
  const hasExternalLink = !isNil(externalInfo.external_edit_url)
  const link =
    allowEdit && hasExternalLink
      ? (externalInfo.external_edit_url as string)
      : externalInfo.external_url
  return { allowEdit, link }
}
